// Module
var code = "<i class=\"fa fa-qrcode\" pw=\"qrcode\"></i> ";
// Exports
export default code;